import IAction from "../../types/IAction";
import { readMessageBack } from "../../utils/readMessageBack";
import actionTypes from "../actionTypes";
import ContactCenterResumen from "../../types/ContactCenterResumen";

export interface PostComisionContactCenterCalcular {
  comisionContactCenterResumen: ContactCenterResumen[];
  postingComisionContactCenter: boolean;
  postingComisionContactCenterError: string;
}

export interface GetComisionContactCenterConsultar {
  comisionContactCenterConsulta: ContactCenterResumen[];
  gettingComisionContactCenter: boolean;
  gettingComisionContactCenterError: string;
}

interface State
  extends PostComisionContactCenterCalcular,
    GetComisionContactCenterConsultar {}

const initialState: State = {
  comisionContactCenterResumen: null,
  postingComisionContactCenter: false,
  postingComisionContactCenterError: null,
  comisionContactCenterConsulta: null,
  gettingComisionContactCenter: false,
  gettingComisionContactCenterError: null
};

export default function comisionContactCenterReducer(
  state: State = initialState,
  action: IAction
): State {
  const snapshot = snapshotAction(state, action);

  state != snapshot &&
    !action.type.endsWith("_PENDING") &&
    action.meta &&
    action.meta.resolver &&
    action.meta.resolver({
      fulfilled: action.type.endsWith("_FULFILLED"),
      ...snapshot
    });

  return state != snapshot
    ? {
        ...state,
        ...snapshot
      }
    : state;
}

function snapshotAction(state: State = initialState, action: IAction) {
  switch (action.type) {
    case `${actionTypes.POST_COMISION_CONTACT_CENTER_CALCULAR}_PENDING`: {
      return {
        postingComisionContactCenter: true,
        postingComisionContactCenterError: null
      };
    }
    case `${actionTypes.POST_COMISION_CONTACT_CENTER_CALCULAR}_REJECTED`: {
      return {
        comisionContactCenterResumen: null,
        postingComisionContactCenter: false,
        postingComisionContactCenterError: readMessageBack(action)
      };
    }
    case `${actionTypes.POST_COMISION_CONTACT_CENTER_CALCULAR}_FULFILLED`: {
      return {
        comisionContactCenterResumen: action.payload.data,
        postingComisionContactCenter: false,
        postingComisionContactCenterError: null
      };
    }

    case `${actionTypes.GET_COMISION_CONTACT_CENTER_CONSULTAR}_PENDING`: {
      return {
        gettingComisionContactCenter: true,
        gettingComisionContactCenterError: null
      };
    }
    case `${actionTypes.GET_COMISION_CONTACT_CENTER_CONSULTAR}_REJECTED`: {
      return {
        comisionContactCenterConsulta: null,
        gettingComisionContactCenter: false,
        gettingComisionContactCenterError: readMessageBack(action)
      };
    }
    case `${actionTypes.GET_COMISION_CONTACT_CENTER_CONSULTAR}_FULFILLED`: {
      return {
        comisionContactCenterConsulta: action.payload.data,
        gettingComisionContactCenter: false,
        gettingComisionContactCenterError: null
      };
    }

    default:
      return state;
  }
}
